module.exports = __webpack_public_path__ + "static/media/default.f6d34189.png";


//////////////////
// WEBPACK FOOTER
// ./src/carReplace/index/default.png
// module id = 1190
// module chunks = 0